import React from "react";
import Grid from "../components/homepage/grid";

const indexContainer = () => <div>Content</div>;

export default indexContainer;
